/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import BetManager from '../../../Playbar/BetManager';
import InjectableComponent from '../../../Utility/Component/ComponentReference/InjectableComponent';
import { ReferenceGroup } from '../../../Utility/Component/ComponentReference/ReferenceGroup';
import ISymbolData from '../../ISymbolData';
import StreakTrackerFilterBase from './StreakTrackerFilterBase';

/** @hidden */
// tslint:disable-next-line:typedef
const property = cc._decorator.property;

/** Filter for symbols that are on an active payline. */
@cc._decorator.ccclass
export default class BetLevelFilter extends StreakTrackerFilterBase
{
    /** @hidden */
    @property({ type: InjectableComponent, visible: true })
    private _betManagerRef: InjectableComponent<BetManager> = new InjectableComponent(ReferenceGroup.MainGame);

    @property({ type: cc.Integer, visible: true })
    private _betConfigID: number = 0;

    protected setContexts(): void
    {
        this._betManagerRef.SetContext(BetManager);
    }

    /** Filter out symbols that are not on active payline. */
    public Filter = (symbols: ISymbolData[]) =>
    {
        if (this._betManagerRef.Value.CurrentBetConfig.betID === this._betConfigID)
        {
            return symbols;
        }
        else
        {
            return [];
        }
    }
}
